/*
 * @Author: your name
 * @Date: 2021-07-13 21:09:33
 * @LastEditTime: 2022-10-21 09:45:00
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\utils\axios\common.js
 */
import Http from '@/utils/httpRequest'
const axios = new Http()

export default {
  getGcjsxmList: data => {
    //操作列表[获取测绘项目委托/项目进度查询和办理列表]
    return axios.post('/applet/jdcx/public/progressqQuery', data)
  },
  getOperationInfo: () => {
    return axios.get('/applet/public/getOperationInfo')
  },
  getHomeConfig: data => {
    // 首页菜单列表
    return axios.get('/applet/public/homeConfig', {data})
  },
  getLoginToken: data => {
    // 用户单点登录的token及用户信息
    return axios.post('/Login/dchy/public/LoginInByXaToken', data)
  },
  lookupDict: data => {
    //字典
    console.log('lookupDict', data)
    return axios.get('/common/public/lookupDict', data)
  },
  getUserInfo: data => {
    return axios.get('appletSSO/public/LoginAndForOnlineUserInfo', data)
  }
}
